import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Google from "../../assets/img/google.svg";
import Apple from "../../assets/img/apple.svg";
import userService from '../../Services/UserService';
import { Button } from '@headlessui/react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useAuth from '../../hooks/useAuth';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
 
import LoginLogo from "../../assets/img/logo-large.png";
import UserService from '../../Services/UserService';
import { Icon } from "../../Components/Landing/Icon";
import LandingHeader from "../../Components/Landing/LandingHeader";
import LandingFooter from "../../Components/Landing/LandingFooter";

interface FormForgotPassword {
  email: string;
}
const ForgotPassword: React.FC = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const auth = useAuth();

  const schema = yup.object().shape({
    email: yup.string().email('Email format is invalid').required('Email is required'),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<FormForgotPassword>({
    resolver: yupResolver(schema),
    mode: 'onSubmit',
  });

  const watchFields = watch();

  useEffect(() => {
    setErrorMessage('');
  }, [watchFields]);

  async function onSubmit() {
    try {
        const email = watchFields.email;  
        const result = await UserService.SendForgotPassword(email); 
        console.log(result);
        if (result?.status === 200) {
          console.log(result?.status);
            toast.success('Mail sent to your registered email Id', {
                position: 'top-right',
            });
            setTimeout(() => {
              navigate(process.env.REACT_APP_PublicPath + "/login", { replace: true });
            }, 2000); 
        }else if(result?.status === 401){
          console.log(result?.status);
          toast.error('You are not authorized to perform this action', {
            position: 'top-right',            
          });
          setTimeout(() => {
            navigate("/registration", { replace: true });
        }, 2000); 
        } else {
            toast.error('Failed to send email', {
                position: 'top-right',
            });
        }
    } catch (error) {
        toast.error("Something went wrong, Please try again", {
            position: 'top-right',
        });
    }
}


  return (
    <div className="flex min-h-screen flex-col font-jakarta text-ink antialiased">
      <LandingHeader />
      <div className="flex-1 flex items-center justify-center bg-brand-mist">
        <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
          <h2 className="text-2xl font-extrabold tracking-tight mb-5 text-left">Reset your password</h2>
          <p className='text-sm font-normal'> Enter your email and we'll send you a link to reset your password.</p>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6 mt-6">
            <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              id="Email"
              type="Email"
              {...register('email')}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
              placeholder="you@example.com"
            />
            {errors.email && <p className="text-red-500 text-xs">{errors.email.message}</p>}
            </div>
            <button
              type="submit"
              className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-brand-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2">
              Reset Password <Icon name="arrow" className="h-4 w-4" />
            </button>
          </form>

        </div>
      </div>
      <LandingFooter />
    </div>

  );
};

export default ForgotPassword;